export default __webpack_public_path__ + "static/media/cejas-hombre.06a71edd.png";